<template>
    <view>
        <div class="content_page">
    <HeaderPage/>
    <div class="container">
        <div class="row">
            <div class="col-md-12 news_page_box">
                <div class="path" v-if="pageerror==0">
                    <i class="fa fa-television"></i>当前位置： <span v-if="newsColumn.name">{{newsColumn.name}}&nbsp;>&nbsp;</span>{{ subColumnName }}
                </div>
                <div class="path" v-if="pageerror==1">
                    <i class="fa fa-television"></i>当前位置： 系统错误提示
                </div>
               <div class="content" v-if="pageerror==0">
                    <h2>{{basic.title}}</h2>
                    <div class="type">
                        发布日期：{{formatTimestamp(basic.ctime)}} <span style="padding-left:10px;" v-if="basic.infofrom">来源：{{basic.infofrom}}</span><span style="padding-left:10px;" v-if="basic.editor">编辑：{{basic.editor}}</span>
                    </div>
                    <div class="album_box">
                        <!-- 轮播 -->
                        <div id="demo" class="carousel slide Album_news" data-bs-ride="carousel">

                            <!-- 指标/点 -->
                            <div class="carousel-indicators">
                                <button type="button" data-bs-target="#demo" v-for="(item,index) in photoList" :key="index" :data-bs-slide-to="index" :class="index>0?'':'active'"></button>
                            </div>

                            <!-- 幻灯片/轮播 -->
                            <div class="carousel-inner">
                                <div v-for="(item,index) in photoList" :key="index" :data-bs-slide-to="index" :class="index>0?'':'active'" class="carousel-item">
                                    <img :src="'https://images.ztnews.net'+item.image">
                                </div>
                            </div>

                            <!-- 左右控件/图标 -->
                            <button class="carousel-control-prev" type="button" data-bs-target="#demo" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#demo" data-bs-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </button>
                        </div> 
                        <div class="thumb" style="display:none">
                            <div data-bs-target="#demo" v-for="(item,index) in photoList" :key="index" :data-bs-slide-to="index" class="thumb_img" :class="index>0?'':'active'"><img :src="'https://images.ztnews.net'+item.image"></div>
                            <div style="clear:both"></div>
                        </div>
                        <div style="font-size:18px; line-height:2em; text-indent:35px; margin-top:15px;">{{basic.description }}</div>
                    </div>               
                </div>
                <div id="loading-mask" v-if="isLodding == 1">
                    <div class="loading-wrapper">
                        <span class="loading-dot loading-dot-spin"><i></i><i></i><i></i><i></i></span>
                    </div>
                </div>
                <div style="text-align:center; position: absolute; top:25%; width: 100%;" v-if="pageerror==1">
                    <div><img src="../../assets/images/nodatamsg.png"  style="width:350px; height:auto;"></div>
                    <div style="color:#999999; margin-top:10px;">内容不存在或预览过期~</div>
                </div>
            </div>
            <!--div class="col-md-4 news_page_right">
                <RightPage/>
            </div-->
        </div>
    </div>
</div>
    </view>
</template>
<script>
    import HeaderPage from '@/components/HeaderUnit.vue'
    //import RightPage from '../../components/RightUnit.vue'
    import { post } from '../../request'; 
    export default {
        components: {
            HeaderPage,
            //RightPage,
        },
        data() {
            return {
                pageerror: 0,
                previewKey: '',
                isLodding: 1,
                newsId:'',
                basic: {},
                photoList: [],
                newsColumn: [],
                title: '巧家新闻网—巧家县第一新闻门户网站',
                keywords: ['巧家新闻','巧家','白鹤滩','巧家县','巧家新闻网'],
                description: '巧家县第一新闻门户网站，巧家新闻网由中共巧家县委宣传部主办、巧家县人民政府新闻中心承办，是对外宣传推介巧家、展示巧家形象、外界了解巧家的重要网络平台。'
            }
        },
        created() {
            this.previewKey = this.$route.query.previewKey
            // watch 路由的参数，以便再次获取数据
            this.$watch(
            () => this.$route.params,
            () => {
                this.newsId = this.$route.params.id.replace(/\.html$/, '')
                console.log(this.newsId)
                this.getPhotos()
            },
            // 组件创建完后获取数据，
            // 此时 data 已经被 observed 了
            { immediate: true }
            )
        },
        computed: {  
            subColumnName() {  
                return this.newsColumn && this.newsColumn['0'] ? this.newsColumn['0'].name : null;  
            }
        },  
        mounted() {
            this.setTitle();  
            this.setKeywords();  
            this.setDescription();  
        },
        methods: {
            formatTimestamp(timestamp) {  
                return this.$formatTimeAgo(timestamp); // 调用全局方法  
            }, 
            setTitle() {  
                document.title = this.title; // 设置标题  
            },  
            setKeywords() {  
                const metaKeywords = document.createElement('meta');  
                metaKeywords.name = 'keywords';  
                metaKeywords.content = this.keywords.join(','); // 设置关键词  
                document.head.appendChild(metaKeywords);  
            },  
            setDescription() {  
                const metaDescription = document.createElement('meta');  
                metaDescription.name = 'description';  
                metaDescription.content = this.description; // 设置描述  
                document.head.appendChild(metaDescription);  
            },  
            async getPhotos() {  
                let that = this
                let url = this.newsId
                that.isLodding = 1
                try {  
                    const postData = {};  
                    if(that.previewKey){
                        url = that.newsId+'?previewKey='+this.previewKey
                    }
                    const response = await post('image/'+url, postData);  
                    //console.log(response)
                    that.isLodding = 0
                    this.pageerror = 0 
                    document.title = response.basic.title
                    this.basic = response.basic
                    this.photoList = response.images
                    that.newsColumn = response.column
                } catch (error) {  
                    this.pageerror = 1 
                    that.isLodding = 0
                }  
            },  
        },
    }
</script>
<style scoped>
.content_page{ width: 100%; background: #ffffff;}

</style>